module.exports = __webpack_public_path__ + "static/img/shushiSkill.0bdab47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/shushiSkill.png
// module id = wKl3
// module chunks = 0